import { Stack } from "@mantine/core";
import { useAppForm } from "../../hooks/preferenceForm";
import { CompleteDenturePreferences } from "./components/CompleteDenturePreferences";
import { PartialDenturePreferences } from "./components/PartialDenturePreferences";
import { ProtocolPreferences } from "./components/ProtocolPreferences";
import { SplintPreferences } from "./components/SplintPreferences";
import { getRemovablePreferenceDefaults } from "./removablePreferenceForm";

const RemovablePreferences = () => {
  const form = useAppForm({
    defaultValues: getRemovablePreferenceDefaults(),
  });

  return (
    <form>
      <Stack pb="s16">
        <CompleteDenturePreferences form={form} />

        <PartialDenturePreferences form={form} />

        <ProtocolPreferences form={form} />

        <SplintPreferences form={form} />
      </Stack>
    </form>
  );
};

export default RemovablePreferences;
